<header class="py-4">
  <div class="container-fluid">
    <div class="row align-items-top justify-content-center">
      <div class="col order-0">
        <figure class="logo-header">
          <img [src]="logoUrlColonial" class="w-100 h-100 object-fit-container" alt="La Colonial de Seguro">
        </figure>
      </div>
      <div class="col-12 col-md order-md-2 order-last">
        <figure class="logo-header mt-5 mt-md-0 mx-auto">
          <img [ngSrc]="logoUrl" priority width="190" height="74.46" alt="Vivir Seguro - La Colonial de Seguro">
        </figure>
      </div>
      <!-- Both account and apps live in this one column so they stay side by side; as
           separate columns the account button was laid out before the centre logo -->
      <div class="col order-md-last d-flex align-items-start justify-content-end gap-2">
        <button
          class="btn btn-products btn-sm btn-outline-secondary border-0 rounded-circle p-2 d-flex align-items-center justify-content-center"
          type="button" data-bs-toggle="offcanvas" data-bs-target="#productsOffcanvas"
          aria-controls="productsOffcanvas">
          <app-icon name="grip" [size]="26" class="lucide-grip-icon"></app-icon>
        </button>
        <div class="dropdown">
          <button
            class="btn btn-login btn-sm btn-outline-secondary border-0 rounded-circle p-2 d-flex align-items-center justify-content-center"
            type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <app-icon name="circle-user" [size]="26" class="lucide-circle-user-icon"></app-icon>
          </button>
          <ul class="dropdown-menu dropdown-menu-end text-small">
            @if (authRetails) {
            <li>
              <h6 class="dropdown-header">{{ userFullName }}</h6>
            </li>
            <li><button class="dropdown-item small" type="button" (click)="logout()">Cerrar sesión</button></li>
            } @else {
            <li><button class="dropdown-item small" type="button" (click)="login()">Iniciar sesión</button></li>
            <li><button class="dropdown-item small" type="button" (click)="register()">Registrarse</button></li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
</header>

<div class="offcanvas offcanvas-end offcanvas-shop bg-body-tertiary p-0" style="min-width:300px;" tabindex="-1"
  id="productsOffcanvas" aria-labelledby="productsOffcanvasLabel" data-bs-scroll="true" data-bs-backdrop="false">
  <div class="offcanvas-body">
    <div class="p-2 mb-3 d-flex align-items-center justify-content-between">
      <div class="fw-semibold">
        Cotiza o adquiere un nuevo seguro
      </div>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Cerrar"></button>
    </div>
    <div class="p-2 bg-white apps-nav rounded-4">
      <a class="position-relative border d-flex item-app-link-armalo-tu" href="https://www.armalotu.com.do/">
        <div
          class="indicator transition-03s position-absolute mx-auto start-0 end-0 top-0 rounded-bottom-4 rounded-top-0 border-bottom border-start border-end"
          style="width:50px; height:8px;"></div><img src="assets/img/armalotu.png"
          alt="Seguro para &lt;br /&gt; &lt;strong&gt;tu vehículo&lt;/strong&gt;">
      </a>
      <a class="position-relative border d-flex item-app-link-emprende-seguro"
        href="http://emprendesegurolacolonial.com.do/">
        <div
          class="indicator transition-03s position-absolute mx-auto start-0 end-0 top-0 rounded-bottom-4 rounded-top-0 border-bottom border-start border-end"
          style="width:50px; height:8px;"></div><img src="assets/img/emprendeseguro.png"
          alt="Seguro para &lt;br /&gt; &lt;strong&gt;tu negocio&lt;/strong&gt;">
      </a>
      <a class="position-relative border d-flex item-app-link-hogar-seguro" href="https://www.hogarseguro.do/">
        <div
          class="indicator transition-03s position-absolute mx-auto start-0 end-0 top-0 rounded-bottom-4 rounded-top-0 border-bottom border-start border-end"
          style="width:50px; height:8px;"></div><img src="assets/img/hogarseguro.png"
          alt="Asegura tu &lt;br /&gt; &lt;strong&gt;vivienda&lt;/strong&gt;">
      </a>
      <a class="position-relative border d-flex item-app-link-viaja-seguro" href="https://www.viajaseguro.do/">
        <div
          class="indicator transition-03s position-absolute mx-auto start-0 end-0 top-0 rounded-bottom-4 rounded-top-0 border-bottom border-start border-end"
          style="width:50px; height:8px;"></div><img src="assets/img/viajaseguro.png"
          alt="Asegura tu &lt;br /&gt; próximo &lt;strong&gt;viaje&lt;/strong&gt;">
      </a>
      <a class="position-relative border d-flex item-app-link-siguelotu" href="https://www.siguelotu.com.do/">
        <div
          class="indicator transition-03s position-absolute mx-auto start-0 end-0 top-0 rounded-bottom-4 rounded-top-0 border-bottom border-start border-end"
          style="width:50px; height:8px;"></div><img src="assets/img/siguelotu.png"
          alt="Seguimiento a &lt;strong&gt;tus reclamaciones&lt;/strong&gt;">
      </a>
    </div>
  </div>
</div>